import { useEffect, useState } from "react";
import { clientCMSbanner } from "../../sanity/clientCMSbanner.js";
import Carousel from "react-bootstrap/Carousel";
import Container from "react-bootstrap/Container";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "./HeroSection.css";

export default function HeroSection() {
  const [allBannersData, setAllBannersData] = useState(null);
  const [dataContainer, setDataContainer] = useState(null);

  useEffect(() => {
    setDataContainer(
      <div>
        <SkeletonTheme baseColor="#f7f7f7" highlightColor="#dddddd">
          <Skeleton count={1} className="loading-container-hero-section" />
        </SkeletonTheme>
      </div>,
    );
    clientCMSbanner
      .fetch(
        `*[_type == "banner"] | order(publishedAt desc) {
        title,
        mainImage{
            asset->{
            _id,
            url
            },
        },
        mobileImage{
            asset->{
            _id,
            url
            },
        },
        wideImage{
            asset->{
            _id,
            url
            },
        },
        link,
        external,
        publishedAt
    }`,
      )
      .then((data) => {
        setAllBannersData(data);
        if (data.length === 0)
          setDataContainer(
            <div className="hero-section-item">
              <div className="hero-section-img-backup" />
              <div className="hero-section-img-mobile-backup" />
            </div>,
          );
      })
      .catch((error) => {
        console.error("An error occurred:", error.message);
        if (
          !allBannersData ||
          allBannersData === null ||
          allBannersData.length === 0
        )
          setDataContainer(
            <div className="hero-section-item">
              <div className="hero-section-img-backup" />
              <div className="hero-section-img-mobile-backup" />
            </div>,
          );
        else
          setDataContainer(
            <div>
              <SkeletonTheme baseColor="#f7f7f7" highlightColor="#dddddd">
                <Skeleton
                  count={1}
                  className="loading-container-hero-section"
                />
              </SkeletonTheme>
            </div>,
          );
      });
  }, []);

  return (
    <Container fluid className="hero-section">
      <Carousel
        controls={true}
        indicators={true}
        fade
        interval={12000}
        touch={true}
        pause={false}
        className="hero-section-carousel"
      >
        {allBannersData && allBannersData.length > 0
          ? allBannersData &&
            allBannersData.map((banner, index) => (
              <Carousel.Item key={index} className="hero-section-item">
                <a
                  href={banner.link}
                  rel="noopener noreferrer"
                  target={banner.external ? "_blank" : "_self"}
                >
                  <img
                    src={banner.mainImage.asset.url}
                    className="hero-section-img"
                    alt="Banner Grupo Krause"
                    fetchpriority="high"
                  />
                  <img
                    src={banner.mobileImage.asset.url}
                    className="hero-section-img-mobile"
                    alt="Banner Grupo Krause"
                    fetchpriority="high"
                  />
                  <img
                    src={banner.wideImage.asset.url}
                    className="hero-section-img-wide"
                    alt="Banner Grupo Krause"
                    fetchpriority="high"
                  />
                </a>
              </Carousel.Item>
            ))
          : dataContainer}
      </Carousel>
    </Container>
  );
}
